module.exports = __webpack_public_path__ + "img/logo.33443341.png";